import abcdaImg from '@/assets/images/melanome/abcde-a.png?url';
import abcdbImg from '@/assets/images/melanome/abcde-b.png?url';
import abcdcImg from '@/assets/images/melanome/abcde-c.png?url';
import abcddImg from '@/assets/images/melanome/abcde-d.png?url';
import abcdeImg from '@/assets/images/melanome/abcde-e.png?url';
import examenPiedImg from '@/assets/images/melanome/examen-pied.jpg?url';
import examenMainArriereCouImg from '@/assets/images/melanome/examen-main-arriere-cou.jpg?url';
import examenMainJambesImg from '@/assets/images/melanome/examen-main-jambes.jpg?url';

export const MODAL_CONTENT_MELANOMA = {
  RISK: `
<b>Facteurs de risques externes :</b>

<b>Exposition fréquente aux UV :</b>
- <b>UV artificiels</b> : en atteignant la peau, les doses excessives d'UV (ex : cabine de bronzage UV) agressent les cellules cutanées et peuvent provoquer des dommages irréversibles dans les gènes des cellules exposées.
- <b>Pendant l'activité professionnelle</b> (UV, arsenic, hydrocarbures aromatiques polycycliques retrouvés dans le charbon et le pétrole) : c'est le cas des personnes exerçant un travail en extérieur ou de celles qui font de la soudure des métaux, de la sidérurgie, de la radiologie médicale et industrielle, ou qui utilisent des pesticides arsenicaux.
- <b>Pendant l'enfance :</b> expositions prolongées au soleil, brûlures solaires ou expositions intermittentes et intenses (coups de soleil) pendant l'enfance et l'adolescence. 80% des cancers de la peau sont liés à des expositions excessives au soleil, principalement des expositions régulières et intenses pendant l'enfance.

<b>Facteurs de risques internes :</b>

<b>Les antécédents familiaux et prédispositions génétiques :</b>
- Antécédent personnel de cancer de la peau
- Antécédents familiaux : si au moins deux parents du premier degré (père, mère, frère, sœur) ont eu un mélanome
  - L'étude de familles avec une forte fréquence de mélanome a abouti à l'identification de gènes en cause. Les personnes porteuses de mutations sur ces gènes sont particulièrement suivies.

<b>Caractéristiques personnelles :</b>
- Bronzage difficile : sensibilité aux rayons UV, peau blanche ou claire avec taches de rousseur multiples et des cheveux blonds ou roux. Plus la peau, les cheveux et les yeux sont clairs, plus le risque de mélanome est important.
- Présence de nombreux grains de beauté (≥ 40) ou des grains de beauté larges (> 5mm) et irréguliers.

<b>L'immunodépression</b> (prise d'un traitement immunosuppresseur par exemple) est également un facteur favorisant la survenue d'un mélanome.
`,

  EXAMEN: `
<b>Auto-examen en 3 temps</b>

<b>1/ Examen direct</b>
Observation à l'œil nu de :
- La paume des mains
- La plante des pieds
- Les bras et avant-bras
- Les cuisses
- Les jambes

<b>2/ Examen avec miroir en pied</b>
- Se placer devant le miroir
- Examiner sa peau de haut en bas
- Tourner le miroir sur les côtés gauche et droit de votre corps, les bras levés à la verticale

<img src="${examenPiedImg}" />
<i>Examen avec miroir en pied, les bras levés, de face puis de chaque côté</i>

<b>3/ Examen avec miroir à main</b>
- Examiner la face interne, externe et postérieure du mollet et de la cuisse
- Examiner la face postérieure des bras, la nuque, le dos, le cuir chevelu et la région génitale
- Demander de l'aide pour les zones difficiles (cuir chevelu)

<img src="${examenMainArriereCouImg}" />
<i>Examen avec miroir à main — arrière cou, cuir chevelu, dos</i>

<img src="${examenMainJambesImg}" />
<i>Examen avec miroir à main — jambes, fesses, organes génitaux</i>
`,

  ABCD_METHOD: `
- La règle ABCDE est la méthode de référence en France
- L'acronyme ABCDE signifie : <b>A = asymétrie ; B = bord ; C = couleur ; D = diamètre ; E = évolutivité</b>
- Une lésion mélanocytaire est considérée comme <b>suspecte si 2 de ces critères sont validés</b> (<b>le critère E</b> étant le critère le plus pertinent)

<i>Illustrations : images du haut = lésions suspectes</i>

<b>A comme Asymétrique</b>
Grain de beauté de forme ni ronde ni ovale, dont les couleurs et les reliefs ne sont pas régulièrement répartis autour du centre.
<img src="${abcdaImg}" />

<b>B comme Bords irréguliers</b>
Bords mal délimités.
<img src="${abcdbImg}" />

<b>C comme Couleur non homogène</b>
Présence désordonnée de plusieurs couleurs (noir, bleu, marron, rouge ou blanc).
<img src="${abcdcImg}" />

<b>D comme Diamètre</b>
Diamètre en augmentation.
<img src="${abcddImg}" />

<b>E comme Évolution</b>
Changement rapide de taille, de forme, de couleur et/ou d'épaisseur.
<img src="${abcdeImg}" />

+ Principe du «<b>vilain petit canard</b>» : grain de beauté ou tache qui se démarque des autres.
`,

  TREATMENT: `
En cas de lésion(s) suspecte(s), le dermatologue peut pratiquer <b>l'exérèse diagnostique</b> (ablation du mélanome).

Le prélèvement est envoyé en laboratoire pour analyse anatomopathologique afin de confirmer le mélanome.

En cas de diagnostic confirmé du mélanome, le dermatologue peut demander un <b>bilan complémentaire</b> adapté à chaque cas selon le type de mélanome et son stade évolutif :
- Bilan sanguin
- Échographie abdominale
- Scanner thoraco-abdomino-pelvien
- IRM cérébrale, hépatique
- Tomographie

Le traitement est ensuite décidé selon le type, la gravité et le stade du mélanome :
- Ablation localisée du mélanome
- <b>Pour les stades plus avancés,</b> en complément de l'ablation : exérèse chirurgicale des métastases, chimiothérapie, immunothérapie ou radiothérapie
`,

  HYGIENE: `
- Mangez au moins 5 portions de <b>fruits et légumes</b> frais par jour
- Consommez au moins 1 féculent complet par jour
- Mangez des légumes secs au moins 2 fois par semaine
- Utilisez des huiles végétales et des cuissons vapeurs
- Privilégiez la <b>volaille</b> à la viande rouge, et limiter la consommation de viande rouge à 500g par semaine
- Mangez à heure régulière
- Buvez au moins 1,5l d'eau par jour
- <b>Tabac</b> : le tabagisme arrive en tête de toutes les causes de cancers, dont le cancer de la peau, loin devant les autres facteurs de risques, qu'il soit passif ou actif.
- <b>Alcool</b> : l'alcool représente la deuxième cause évitable de mortalité par cancer. Dès une consommation moyenne d'un verre par jour, l'augmentation du risque de développer un cancer est significative.
  - <u>Recommandations de santé publique</u> : modérez votre consommation (pas plus de 2 verres standards par jour, et avoir des jours dans la semaine sans consommation).
`,

  PHYSIQUE: `
- L'activité physique diminue le risque de survenue de tous les cancers
- Pratiquer <b>au moins 30 minutes d'activité physique modérée à élevée</b> par jour au moins 5 jours par semaine (évitez de rester 2 jours consécutifs sans pratiquer)
- Positions assise ou allongée : marchez quelques minutes toutes les <b>90 à 120 minutes</b> pour limiter la sédentarité
- Utilisez un objet connecté (podomètre, application mobile) pour suivre votre nombre de pas quotidiens et l'augmenter !
- Autres conseils pour augmenter votre activité physique au quotidien :
  - Vous donner l'objectif d'effectuer l'équivalent de 10 000 pas quotidiens
  - Privilégier les escaliers à l'ascenseur ou l'escalator
  - Favoriser les trajets à pieds
`,
};
